<template>
    <div>
        <Alert :alert="alert" />

        <div v-if="loading" class="d-flex flex-spaced-fixed">
            <div class="cr-spinner-small"></div>
            <p>{{ $t('waitMoment') }}...</p>
        </div>

        <template v-else>
            <div
                v-if="$scope.checkoutPreferences.enableExpressShipping && enableExpress"
                class="frame mb"
            >
                <div class="d-flex flex-align-center">
                    <span class="mr-auto">
                        Ative essa opção para receber o seu pedido até
                        <strong>{{ express.days }} dias antes</strong> por mais
                        <strong>{{ $f.formatMoney(express.price) }}</strong>
                    </span>

                    <div class="ml-auto flex-child-fixed">
                        <input
                            id="express-switch"
                            :checked="cart.expresso"
                            class="cr-switch"
                            type="checkbox"
                            @change="toggleExpressShipping"
                        />
                        <label for="express-switch"></label>
                    </div>
                </div>

                <p v-if="express.except">* Indisponível para: {{ express.except }}</p>
            </div>

            <ul v-if="quotation" class="checkout-options">
                <li v-for="carrier in quotation.responses">
                    <input
                        :id="`carrier-${carrier.id}`"
                        :checked="selectedCarrier === carrier"
                        class="cr-radio"
                        type="radio"
                    />
                    <label
                        :for="`carrier-${carrier.id}`"
                        @click="selectCarrier(carrier)"
                        class="flex-grid"
                    >
                        <div class="checkout-option-content flex-xs-9 flex-md-8">
                            <div class="mx-0">
                                <img
                                    v-if="carrier.prime"
                                    :src="`${$scope.CDN_IMAGES}/images/site/2021/prime/selo_prime_02_378bcb.svg`"
                                    alt="Selo Prime"
                                    class="checkout-option-content-img"
                                />
                                <p class="my-0">
                                    <span>({{ carrier.name }})</span>
                                    <span v-if="carrier.deadline > 0 && carrier.carrier_id != 3">
                                        <span
                                            v-if="
                                                carrier.carrier_id === 4 ||
                                                carrier.carrier_id === 81027
                                            "
                                            v-html="
                                                $t('untilDateXHtml', [
                                                    getFormattedFinalForecast(carrier),
                                                ])
                                            "
                                        />
                                        <span
                                            v-else
                                            v-html="
                                                $t('dateToXHtml', [
                                                    getFormattedFinalForecast(carrier),
                                                ])
                                            "
                                        />
                                    </span>
                                </p>
                            </div>

                            <p
                                v-if="
                                    cart.expresso &&
                                    carrier.expressEnabled &&
                                    carrier.actual_additional_price > 0
                                "
                            >
                                {{ $t('_shop.withExpressProduction') }}
                            </p>

                            <template v-if="false && carrier.carrier_id === 81024">
                                <p class="text-small">{{ $t('observations') }}:</p>
                                <ul class="text-small">
                                    <li v-for="t in $t('_checkout._shipping.motoBoyObservations')">
                                        {{ t }}
                                    </li>
                                </ul>
                            </template>

                            <template
                                v-if="
                                    carrier.school_branch_id &&
                                    quotation.available_schools_branches &&
                                    quotation.available_schools_branches[carrier.school_branch_id]
                                "
                            >
                                <p>
                                    Em
                                    <strong>{{
                                        quotation.available_schools_branches[
                                            carrier.school_branch_id
                                        ].school
                                    }}</strong>
                                    <a
                                        @click.prevent.stop="
                                            clickChangeSchoolBranch(
                                                quotation.available_schools_branches[
                                                    carrier.school_branch_id
                                                ].id
                                            )
                                        "
                                        >(Alterar)</a
                                    >
                                </p>
                                <p class="text-small">
                                    {{
                                        quotation.available_schools_branches[
                                            carrier.school_branch_id
                                        ].address
                                    }},
                                    {{
                                        quotation.available_schools_branches[
                                            carrier.school_branch_id
                                        ].number
                                    }}
                                    -
                                    {{
                                        quotation.available_schools_branches[
                                            carrier.school_branch_id
                                        ].city
                                    }}
                                    /
                                    {{
                                        quotation.available_schools_branches[
                                            carrier.school_branch_id
                                        ].state
                                    }}
                                    - CEP:
                                    {{
                                        quotation.available_schools_branches[
                                            carrier.school_branch_id
                                        ].postcode
                                    }}
                                </p>
                            </template>
                        </div>
                        <p class="flex-xs-3 flex-md-4 price-carrier text-right">
                            <span
                                v-if="
                                    (carrier.price == 0 || carrier.prime) &&
                                    carrier.carrier_id != 3 &&
                                    carrier.actual_additional_price === 0
                                "
                                class="free-price"
                            >
                                {{ $t('free') }}
                            </span>
                            <span v-else-if="carrier.price + carrier.actual_additional_price > 0">
                                {{
                                    $f.formatMoney(carrier.price + carrier.actual_additional_price)
                                }}
                            </span>
                        </p>
                        <div class="mt-1 physical-store-info" v-if="carrier.store">
                            <p>
                                {{ carrier.store.address }}, {{ carrier.store.number }} -
                                <template v-if="carrier.store.complement"
                                    >{{ carrier.store.complement }} -
                                </template>
                                {{ carrier.store.neighborhood }} - {{ carrier.store.city }}/{{
                                    carrier.store.uf
                                }}
                                - CEP
                                {{ carrier.store.cep }}
                            </p>
                            <p class="hours">{{ carrier.store.business_hour }}</p>
                        </div>
                    </label>
                </li>
            </ul>

            <div class="alert-danger mt-3" style="font-size: 1rem" v-if="showDeliveryFastMessage">
                Atenção! A entrega do produto está para após o Natal!
            </div>

            <div
                v-if="$scope.IS_SALES_REP && $scope.TENANT_IDENTIFIER === 'chicorei'"
                class="frame mt d-flex flex-align-center"
            >
                <div class="mr">
                    {{ $t('_checkout._shipping.shippingForecast') }}:
                    <span v-if="cart.fixed_shipping_days">
                        {{ $f.formatDate(cart.fixed_shipping_date, 'DD/MM/YY') }}.
                    </span>
                    <span v-else>{{ $t('automatic') }}.</span>
                </div>

                <button
                    class="btn btn-sm ml-auto flex-child-fixed"
                    @click="showShippingDaysModal = true"
                >
                    {{ $t(cart.fixed_shipping_days ? 'toChange' : 'toDefine') }}
                </button>
            </div>
        </template>

        <SelectSchoolBranchModal
            v-if="quotation && quotation.available_schools_branches"
            v-model="changeSchoolBranch"
            :available-schools-branches="quotation.available_schools_branches"
            :actual-branch-school-id="actualBranchSchoolId"
            @selected-school-branch="selectBranchSchool"
        />

        <Modal
            v-if="$scope.IS_SALES_REP && $scope.TENANT_IDENTIFIER === 'chicorei'"
            v-model="showShippingDaysModal"
        >
            <template #title>Alterar previsão de envio</template>
            <SalesRepCartShippingDays
                :initial-days="cart.fixed_shipping_days"
                @done="showShippingDaysModal = false"
                @success="reloadCart"
            />
        </Modal>
    </div>
</template>

<script>
    import Alert from '../../../../submodules/src/componentsV2/surface/alert/Alert.vue';
    import Radio from '../../../../submodules/src/components/input/radio/Radio.vue';
    import BaseCheckoutCarrier from './common/BaseCheckoutCarrier.vue';
    import store from '../../script/store/checkout';
    import SalesRepCartShippingDays from '../sales-rep/SalesRepCartShippingDays.vue';
    import Modal from '../surface/modal/Modal.vue';
    import SelectSchoolBranchModal from '../common/SelectSchoolBranchModal.vue';

    export default {
        name: 'CheckoutCarrier',

        extends: BaseCheckoutCarrier,

        components: {
            SelectSchoolBranchModal,
            SalesRepCartShippingDays,
            Alert,
            Radio,
            Modal,
        },

        data() {
            return {
                showShippingDaysModal: false,
            };
        },

        methods: {
            reloadCart() {
                store.cart.fetch();
            },
        },
    };
</script>
